import { create } from "domain";

export const endpoints = {

    // USER
    userPermissions: '/user-permissions/building/:buildingId', // get user permissions and building id
    // EOP SUMMARY
    eopSummary: '/summary/building/:buildingId', // get EOP summary by building id
    
    // EOP ASSISTANT
    eopAssistant: '/eop_assistant/section/:section_id?sub_section_id=:sub_section_id',

    // CONTACT 
    contacts: '/contacts/:buildingId', // get all contacts of a building

    // DEPARTMENT 
    departments: '/collaborative_team_department/eopTemplateId/:eopTemplateId', // get all departments
    getBuildingDepartmentContacts: '/collaborative_contact_relationship/building/:buildingId/template/:eopTemplateId', // get all contacts of all departments in a building
    getDepartmentContacts: '/collaborative_contact_relationship/building/:buildingId/department/:departmentId', // get all contacts of all departments
    saveDepartmentContacts: '/collaborative_contact_relationship/building/:buildingId', // save contacts of the department
    removeDepartmentContacts: '/collaborative_contact_relationship/building/:buildingId/department/:departmentId', // remove all contacts of the department

    // ICS ROLES
    positions: '/ics/eopTemplateId/:eopTemplateId', // get all positions
    positionContact: '/ics_contactrelationship/building/:buildingId/eopTemplateId/:eopTemplateId', // get all contacts of all positions
    savePositionContacts: '/ics_contactrelationship/building/:buildingId', // save contacts of the position
    deleteAllPositionContacts: '/ics_contactrelationship/building/:buildingId', // delete all contacts of all positions

    // CALENDAR 
    schedules: '/calendar_log/building/:buildingId', // get all events
    createNewSchedule: '/calendar_log/building/:buildingId', // create new event
    editSchedule: '/calendar_log/:scheduleId', // edit event
    deleteSchedule: '/calendar_log/:scheduleId', // delete event

    // FILES
    uploadFile: '/uploadFile/section/:section_id/item/:item_id', // upload one or multiple files
    downloadFile: '/downloadFile/building/:building_id/section/:section_id/file/:file_id', // download one file
    deleteFile: '/deleteFile/building/:building_id/section/:section_id/file/:file_id', // delete one file

    // ASSESSMENT
    assessments: '/assessments_log/building/:buildingId', // get all assess 
    sendAssessmentRequest: '/send_assessments/building/:buildingId/assessment_type/:assessmentTypeId/sub_type/:assessmentSubTypeId', // send assessment request
    deleteAssess: '/assessments_log/delete/:assessId', // delete one assess
    downloadSurvey: '/assessments_log/download/:guid', // download survey by guid

    // THREAT AND HAZARDS 
    threats: '/threat_hazards/building/:buildingId/logs', // get all threats
    createNewThreat: '/threat_hazards/building/:buildingId', // create new threat
    editThreat: '/threat_hazards/:threatId', // edit one threat
    deleteThreat: '/threat_hazards/:threatId', // delete one threat
    threatGoals: '/threat_hazards/building/:buildingId/goals/objectives', // get threat's goals and objectives
    createThreatGoals: '/threat_hazards/:threatId/create/goals', // create threat's goals
    editThreatGoals: '/threat_hazards/:threatId/update/goals/objectives', // update threat's goals
    deleteThreatGoals: '/threat_hazards/:threatId/delete/goals/objectives', // delete threat's goals

    // FUNCTION
    functions: '/functions/building/:buildingId', // get all functions
    createNewFunction: '/functions/building/:buildingId', // create new function
    editFunction: '/functions/update/:functionId', // edit one function
    deleteFunction: '/functions/delete/:functionId', // delete one function

    // FUNCTIONS ASSIGNED TO A THREAT
    getAllFunctionalAssignments: '/functional_assignment/building/:buildingId', // get all functions of a threat
    createFunctionalAssignment: '/functional_assignment/building/:buildingId/threat/:threatId', // save new functional assignment for a threat

    // FUNCTION'S COURSE OF ACTION 
    getCourseOfAction: '/course_of_actions/building/:buildingId/:functionOrThreat', // get course of action of a function
    updateCourseOfAction: '/course_of_actions/building/:buildingId/:functionOrThreat/:funcionThreatId', // create/update course of action of a function

    // THREAT'S COURSE OF ACTION
    getThreatsCourseOfAction: '/course_of_actions/building/:buildingId/threat/:threatId', // get course of action of a threat
    updateThreatesCourseOfAction: '/course_of_actions/threat', // create/update course of action of a threat

    // BASIC PLAN
    eopSectionsByBuildingId: '/eop_sections/building/:buildingId', // get EOP sections of a building id
    verifyIfSectionExistsOnBuilding: '/eop_sections/building/:buildingId/section/:sectionType', // verify if EOP section exists on building id
    eopSectionByStep: '/eop_sections/step/:step_number', // get EOP section by id
    createBasicPlanForBuilding: '/create_basic_plan/building/:buildingId', // create new EOP sections for building
    getEopDocument: '/eop_document/building/:buildingId/section/:sectionType', // get EOP document by building id, section type and sub section type
    updateEopDocument: '/eop_document/building/:buildingId/section/:sectionType', // update EOP document by building id, section type and sub section type
    approveEopDocument: '/approve_eop_document/building/:buildingId/section/:sectionType', // approve EOP document by building id, section type and sub section type

    // CUSTOM EOP SECTIONS
    customEopSectionsByBuildingId: '/custom_eop_sections/building/:buildingId', // get custom EOP sections by building id
    getCustomPageByPageId: '/custom_page/page/:pageId', // get custom EOP section by page id
    createCustomEopSection: '/create_custom_eop_section/building/:buildingId', // create new custom EOP section
    updateCustomEopSection: '/update_custom_eop_section/page/:pageId', // create new custom EOP section
    deleteCustomEopSection: '/delete_custom_eop_section/page/:pageId', // delete custom EOP section by page id

    // RECORD OF CHANGES
    getRecordOfChanges: '/record_of_changes/building/:buildingId', // get EOP Record of Changes

    // RECORD OF DISTRIBUTION
    getRecordOfDistribution: '/record_of_distribution/building/:buildingId', // get EOP Record of Distribution
    downloadEopDocument: '/download_eop_document/building/:buildingId', // download EOP document by building id, section type and sub section type
    sendEOP: '/sendEOP/building/:buildingId', // send EOP
    
};
  